import React, { useState, useEffect } from "react";
import { useUpdatePrimaryInfo } from "../Utils/useUpdatePrimaryInfo";
import useFetchVesselPrimaryInformation from "../Utils/useFetchVesselPrimaryInformation";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "react-toastify/dist/ReactToastify.css";
import "./updatevessel.css";

const UpdatePrimaryVesselForm = ({ vesselId }) => {
  const [collapsedSections, setCollapsedSections] = useState({
    primaryInformation: true,
  });

  const [vesselDescription, setVesselDescription] = useState("");
  const [vesselUse, setVesselUse] = useState([]);
  const [serviceType, setServiceType] = useState("");
  const [pricing, setPricing] = useState("");
  const [paymentPlan, setPaymentPlan] = useState(1);
  const [negotiable, setNegotiable] = useState("true");
  const [vesselType, setVesselType] = useState("");

  // Store initial data for comparison
  const [initialData, setInitialData] = useState({});

  const { data: fetchedData } = useFetchVesselPrimaryInformation(vesselId);
  const { mutate: updatePrimaryInfo, isLoading: isUpdating } = useUpdatePrimaryInfo();

  useEffect(() => {
    if (fetchedData && fetchedData.status === "success") {
      const primaryInfo = fetchedData.data.primaryInformation;
      setVesselDescription(primaryInfo.vesselDescription || "");
      setVesselUse(primaryInfo.vesselUse || []);
      setServiceType(primaryInfo.serviceType || "");
      setPricing(primaryInfo.pricing || "");
      setPaymentPlan(primaryInfo.paymentPlan || 1);
      setNegotiable(primaryInfo.negotiable ? "true" : "false");
      setVesselType(primaryInfo.vesselType || "");

      // Store the initial data for comparison
      setInitialData({
        vesselDescription: primaryInfo.vesselDescription || "",
        vesselUse: primaryInfo.vesselUse || [],
        serviceType: primaryInfo.serviceType || "",
        pricing: primaryInfo.pricing || "",
        paymentPlan: primaryInfo.paymentPlan || 1,
        negotiable: primaryInfo.negotiable ? "true" : "false",
        vesselType: primaryInfo.vesselType || "",
      });
    }
  }, [fetchedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "vesselDescription":
        setVesselDescription(value);
        break;
      case "vesselUse":
        setVesselUse(value.split(",").map((use) => use.trim()));
        break;
      case "serviceType":
        setServiceType(value);
        break;
      case "pricing":
        setPricing(value);
        break;
      case "paymentPlan":
        setPaymentPlan(Number(value));
        break;
      case "negotiable":
        setNegotiable(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Compare the current values with the initial ones and only send changed fields
    const updatedFields = {};
    if (vesselDescription !== initialData.vesselDescription) updatedFields.vesselDescription = vesselDescription;
    if (JSON.stringify(vesselUse) !== JSON.stringify(initialData.vesselUse)) updatedFields.vesselUse = vesselUse;
    if (serviceType !== initialData.serviceType) updatedFields.serviceType = serviceType;
    if (pricing !== initialData.pricing) updatedFields.pricing = pricing;
    if (paymentPlan !== initialData.paymentPlan) updatedFields.paymentPlan = paymentPlan;
    if (negotiable !== initialData.negotiable) updatedFields.negotiable = negotiable === "true";
    // Note: vesselType is read-only, so we don't send it for updating

    // Only send the update request if there are changed fields
    if (Object.keys(updatedFields).length > 0) {
      updatePrimaryInfo(
        {
          vesselId,
          primaryInfo: updatedFields,
        },
        {
          onSuccess: () => {
            toast.success("Vessel information updated successfully!");
          },
          onError: (error) => {
            toast.error(`Error updating vessel information: ${error.message}`);
          },
        }
      );
    } else {
      toast.info("No changes detected.");
    }
  };

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <div className="update-vessel-container">
      <div className="pri" onClick={() => toggleSection("primaryInformation")}>
        <p>Primary Information</p>
        {collapsedSections.primaryInformation ? <IoIosArrowDown /> : <IoIosArrowUp />}
      </div>
      {!collapsedSections.primaryInformation && (
        <form onSubmit={handleSubmit}>
          <label>
            Vessel Type
            <input type="text" name="vesselType" value={vesselType} readOnly disabled />
          </label>
          <label>
            Vessel Description
            <input
              type="text"
              name="vesselDescription"
              value={vesselDescription}
              onChange={handleChange}
              placeholder="Enter"
              required
            />
          </label>
          <label>
            Vessel Use (Comma-separated, e.g., Lease, Transport, Sale)
            <input
              type="text"
              name="vesselUse"
              value={vesselUse.join(", ")}
              onChange={handleChange}
              placeholder="Enter"
              required
            />
          </label>
          <label>
            Service Type
            <input
              type="text"
              name="serviceType"
              value={serviceType}
              onChange={handleChange}
              placeholder="Enter"
              required
            />
          </label>
          <label>
            Pricing ($)
            <input
              type="text"
              name="pricing"
              value={pricing}
              onChange={handleChange}
              placeholder="Enter"
              required
            />
          </label>
          <label>
            Payment Plan
            <input
              type="number"
              name="paymentPlan"
              value={paymentPlan}
              onChange={handleChange}
              placeholder="Enter"
              required
            />
          </label>
          <label>
            Negotiable
            <select name="negotiable" value={negotiable} onChange={handleChange}>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </label>
          <button type="submit" disabled={isUpdating}>
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default UpdatePrimaryVesselForm;

